// 从 saas-editor/src/materialCard/views/materialCard.tsx 搬迁
import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import './material-card.less';

interface TrackInfo {
    [key: string]: any;
}
export type Placement = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

export type titlePlacement =
    | 'top'
    | 'left'
    | 'right'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight'
    | 'leftTop'
    | 'leftBottom'
    | 'rightTop'
    | 'rightBottom';

interface IProps {
    onClick?: Function;
    /** 埋点参数 data-track-xx */
    trackInfo?: TrackInfo;
    cardStyle?: React.CSSProperties;
    /** 卡片宽度 */
    width?: number;
    /** 角标 */
    cornerSrc?: string;
    /**主图src */
    src: string;
    cornerPlacement?: Placement;
    titlePlacement?: titlePlacement;
    /**标题 */
    title?: string;
    /** 自定义渲染节点 */
    renderNode?: React.ReactNode;
}

const CORNER_PLACEMENT_MAP = {
    topLeft: {
        top: 4,
        left: 4,
    },
    topRight: {
        top: 4,
        right: 4,
    },
    bottomLeft: {
        bottom: 4,
        left: 4,
    },
    bottomRight: {
        bottom: 4,
        right: 4,
    },
};

export const MaterialCard = React.memo((props: IProps) => {
    const {
        trackInfo,
        cardStyle,
        width = 108,
        onClick,
        cornerSrc,
        src,
        cornerPlacement,
        titlePlacement,
        title,
        renderNode,
    } = props;

    let tracks = {},
        styles = {},
        cornerStyles = {};

    const defaultCardStyle: React.CSSProperties = {
        width,
    };

    const defaultTrack = {
        'data-type': 'track',
    };

    if (cardStyle) {
        styles = Object.assign({}, defaultCardStyle, cardStyle);
    }

    if (cornerPlacement) {
        cornerStyles = {
            ...CORNER_PLACEMENT_MAP[cornerPlacement],
            position: 'absolute',
        };
    }

    if (trackInfo) {
        tracks = Object.assign({}, defaultTrack, trackInfo);
    }

    const handleClick = () => {
        onClick && onClick();
    };

    return (
        <div
            className="mt-material-card"
            onClick={handleClick}
            {...tracks}
            style={{
                ...defaultCardStyle,
                ...styles,
            }}
        >
            <div className="mt-material-card__main">
                <img src={src} alt="" className="mt-drag-item" />
            </div>
            {title ? (
                titlePlacement ? (
                    <Tooltip title={title} placement={titlePlacement}>
                        <div className="mt-material-card__title">{title}</div>
                    </Tooltip>
                ) : (
                    <div className="mt-material-card__title">{title}</div>
                )
            ) : null}
            {cornerSrc ? (
                <div className="mt-material-card__corner" style={{ ...cornerStyles }}>
                    <img src={cornerSrc} alt="corner" />
                </div>
            ) : null}
            {renderNode ? <div className="mt-material-card__render-node">{renderNode}</div> : null}
        </div>
    );
});
